import { i18n } from '@/commons/utils';
import { getParameters } from '../customer-utils';
import { init as initAddressBook } from './account-address-book';

const URL = {
  ADD_ADDRESS: 'account/addShippingAddress'
};


export const init = () => {
  const form = cube.$id('js-address-book-form');
  const backtoAddressList = cube.$id('js-back-to-address-book-list-button');
  const selectpickers = cube.$$('.selectpicker');

  $(selectpickers).selectpicker('render');
  validator(form);

  const countryGeoCode = cube.$id('countryCodeGeoId');

  if (countryGeoCode) {
    cube.form.address.init(countryGeoCode.value, 'SHIPPING');

    countryGeoCode.addEventListener('change', () => {
      cube.form.address.init(countryGeoCode.value, 'SHIPPING');
    });
  }

  form.on('submit', updateAddress);
  backtoAddressList.on('click', displayAddressList);
};


/**
 * Send a XHR to update an existing customer address
 *
 * @param {Event} e
 */
function updateAddress (e) {
  e.preventDefault();

  const button = cube.$id('js-add-address-button');

  if ($(this).valid()) {


    const parameters = getParameters(this);

    button.disabled = true;

    cube.ajax.post(URL.ADD_ADDRESS, parameters)
      .onSuccess(response => updateAddressSuccess(response, button))
      .onError(response => ajaxError(response, button))
      .call();
  }
};


/**
 * Display the customer addresses and a message if the XHR returns no error.
 *
 * @param {Json} response The XHR response.
 * @param {HTMLElement} button The form submit button.
 */
const updateAddressSuccess = (response, button) => {
  if (ajaxError(response, button))
    return;

  button.disabled = false;
  cube.alert.success(i18n('profile.changesSaved'));

  displayAddressList();
};


/**
 * Reload the customer adresses list
 *
 */
const displayAddressList = () => {
  cube.cartridge('js-address-book')
    .after(initAddressBook)
    .reload();
};


/**
 * Display an error if the XHR returns error(s).
 *
 * @param {Json} response The XHR response.
 * @param {HTMLElement} button The form submit button.
 * @returns {Boolean}
 */
const ajaxError = (response, button) => {
  if (
    typeof response === 'string' ||
    typeof response === 'object' && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message
  ) {
    if (typeof response === 'string')
      cube.alert.error(i18n('error.oc.call'));
    else
      cube.alert.error(response.responseTO.errors[0].message);

    button.disabled = false;

    return true;
  }

  return false;
};


const validator = form => {
  $(form).validate(Object.assign(
    $.validator.cubeOptions,
    {
      unhighlight: (element, errorClass, validClass) => {
        const parent = element.closest('.form-group');
        const { classList } = parent;

        if (element.readonly)
          return;

        classList.remove(errorClass);

        const inputText = cube.$$('#js-address-book-form input[type=text]');
        inputText.forEach((el) => {
          $(el).rules('add', {'emoji': true});
        });

        if (element.value.length && validClass)
          classList.add(validClass);
        else
          classList.remove(validClass);
      },

      rules: {
        title: {
          extendedalphanumeric: true
        },
        name: {
          extendedalphanumeric: true
        },
        mobile: {
          mobile: true
        },
        landline: {
          mobile: true
        },
        surname: {
          extendedalphanumeric: true
        }
      },

      messages: {
        name: {
          required: i18n('shippingAddress.error.nameRequired')
        },
        mobile: {
          required: i18n('shippingAddress.error.mobileRequired')
        },
        landline: {
          required: i18n('.error.landlineRequired')
        },
        streetName: {
          required: i18n('shippingAddress.error.streetNameRequired')
        },
        title: {
          required: i18n('shippingAddress.error.titleRequired')
        }
      },

      ignore: ':hidden:not(.selectpicker), [readonly]'
    }
  ));
};



// WEBPACK FOOTER //
// ./src/customer/account/account-address-book-form.js